import React from "react";
import { BarChart3, Download, Info } from "lucide-react";
import { PrimaryButton } from "../../../../../globalComponents/ui/Button";

/**
 * Renders the page title card and the Excel export action.
 *
 * @param {Object} props
 * @param {Function} props.onDownload - Invoked when Download Excel is clicked.
 * @param {boolean} props.downloadDisabled - Hides the download action when
 *   there is nothing to export (no KPI questions in the current view).
 * @param {"combined"|"byLocation"} props.exportMode - Currently selected sheet
 *   arrangement, passed straight through to handleExport with no translation.
 * @param {Function} props.onExportModeChange - Receives the new "combined" or
 *   "byLocation" mode when a toggle button is clicked.
 * @param {boolean} [props.showExportModeToggle=true] - Whether to show the
 *   Combined/By-Location toggle. Hidden when only one location exists, since
 *   there is nothing to split across.
 * @returns {JSX.Element} The page header card.
 */
const QuickViewHeader = ({ onDownload, downloadDisabled, exportMode, onExportModeChange, showExportModeToggle = true }) => (
  <div className="qv-card qv-header">
    <div className="qv-header__inner">
      <div>
        <h2 className="qv-header__title">
          <BarChart3 size={18} aria-hidden="true" />
          Quick View &amp; Export
        </h2>
        <p className="qv-header__subtitle">
          Review reporting data and export to Excel
        </p>
      </div>
      <div className="qv-header__actions">
        {showExportModeToggle && (
        <div className="qv-toggle-container">
          <span className="qv-toggle-label">Arrange:</span>
          <div className="qv-info-tooltip-container">
            <span className="qv-info-icon"><Info size={12} aria-hidden="true" /></span>
            <div className="qv-info-tooltip">
              <p><strong>Combined:</strong> Values combined across all selected locations.</p>
              <p><strong>By Location:</strong> Separate sheet for each selected location.</p>
            </div>
          </div>
          <div className="qv-toggle-pill">
            <button
              type="button"
              className={`qv-toggle-btn ${exportMode === "combined" ? "qv-toggle-btn--active" : ""}`}
              onClick={() => onExportModeChange("combined")}
            >
              Combined
            </button>
            <button
              type="button"
              className={`qv-toggle-btn ${exportMode === "byLocation" ? "qv-toggle-btn--active" : ""}`}
              onClick={() => onExportModeChange("byLocation")}
            >
              By Location
            </button>
          </div>
        </div>
        )}
        {!downloadDisabled && (
          <PrimaryButton onClick={onDownload}>
            <Download size={16} aria-hidden="true" />
            Download Excel
          </PrimaryButton>
        )}
      </div>
    </div>
  </div>
);

export default QuickViewHeader;
